import { createFileRoute } from '@tanstack/react-router';

import { UnavailabilityOfCast } from '@/view/pages/UnavailabilityOfCast';

export const Route = createFileRoute('/_protected/$programId/indisponibilidade-de-elenco')({
  component: UnavailabilityOfCast,
  context: (context): { title: string } => ({
    ...context,
    title: 'Indisponibilidade de Elenco',
  }),
});
